import { inject, injectable } from 'tsyringe';
import type { IBuyerSurveyClient } from 'interfaceAdapter/gatewaySchemas/IBuyerSurveyClient';
import type { IBuyerUserTokenRepository } from 'application/repositorySchemas/IBuyerUserTokenRepository';
import { IBuyerSurveyQuery } from 'application/querySchemas/IBuyerSurveyQuery';
import type { ISurveyFactory } from 'domain/valueObjects/factories/Survey';
import { ISurvey } from 'domain/entities/Survey/Survey';

@injectable()
export class BuyerSurveyQuery implements IBuyerSurveyQuery {
    constructor(
        @inject('IBuyerUserTokenRepository')
        public readonly buyerUserToken: IBuyerUserTokenRepository,
        @inject('IBuyerSurveyClient')
        public readonly surveyClient: IBuyerSurveyClient,
        @inject('SurveyFactory')
        public readonly factory: ISurveyFactory,
    ) {}

    public async fetch(matchId: number): Promise<ISurvey> {
        const { data, message } = await this.surveyClient.get({
            token: this.buyerUserToken.get() || '',
            matchId,
        });

        if (message) {
            throw new Error(message);
        }

        if (!data) throw new Error('アンケート情報の取得に失敗しました');

        return this.factory.buildSurvey(data);
    }
}
